import { render } from "./wInputGroup.vue?vue&type=template&id=0863f308&ts=true"
import script from "./wInputGroup.vue?vue&type=script&lang=ts"
export * from "./wInputGroup.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__